import { useState, useEffect } from 'react';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';
import EventBus from 'utils/eventBus';

/**
 * Custom hook for managing portal categories
 * @returns {Object} Categories state and methods
 */
export const usePortalCategories = () => {
  const [categories, setCategories] = useState([]);
  const [activeCategoryId, setActiveCategoryId] = useState(0);
  const [loading, setLoading] = useState(true);

  const loadCategories = async () => {
    setLoading(true);
    let res = Storages.MainStorage.getItem(StorageKeys.Keys.PROFILECATEGORY);
    let validCategories = [];

    if (res !== null) {
      res.forEach((element, index) => {
        let profile = Storages.MainStorage.getItem(StorageKeys.Keys.PROFILE + element.id);
        if (profile && profile.category === element.id) {
          element.active = index === 0;
          validCategories.push(element);
        }
      });
    }

    setCategories(validCategories);
    if (validCategories.length > 0) {
      setActiveCategoryId(validCategories[0].id);
    }
    setLoading(false);

    return validCategories;
  };

  var toggleActiveCategory = function (categoryId) {
    setCategories(function (prevCategories) {
      return prevCategories.map(function (item) {
        return Object.assign({}, item, {
          active: categoryId === item.id,
        });
      });
    });
    setActiveCategoryId(categoryId);
  };

  const selectCategoryByIndex = (index) => {
    if (index >= 0 && index < categories.length) {
      const category = categories[index];
      toggleActiveCategory(category.id);
      return category;
    }
    return null;
  };

  useEffect(() => {
    const subscription = EventBus.subscribe('refresh', loadCategories);
    loadCategories();

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return {
    categories,
    activeCategoryId,
    loading,
    toggleActiveCategory,
    selectCategoryByIndex,
    refreshCategories: loadCategories,
  };
};
